export const routes = {
  home: "/",
  downloadApp: "/download-app",
  restaurants: (countryCode?: string) => {
    if (!countryCode) {
      return routes.home
    }
    return `/${countryCode}/restaurants`
  },
  restaurant: (countryCode: string | undefined, identifier: string) => {
    if (!countryCode) {
      return `/restaurants/${identifier}`
    }
    return `/${countryCode}/restaurants/${identifier}`
  },
  checkout: (countryCode: string, identifier: string) => {
    if (!countryCode) {
      return `/restaurants/${identifier}/checkout`
    }
    return `/${countryCode}/restaurants/${identifier}/checkout`
  },
  profile: (countryCode: string | undefined) => {
    if (!countryCode) {
      return `/profile`
    }
    return `/${countryCode}/profile`
  },
  profileBirthday: (countryCode: string | undefined) => {
    if (!countryCode) {
      return `/profile/birthday`
    }
    return `/${countryCode}/profile/birthday`
  },
  orderStatus: "/order-status",
  notFound: "/404",
  legal: {
    overview: "/legal",
    terms: "/legal/terms",
    privacy: "/legal/privacy",
    marketing: "/legal/marketing",
    cookies: "/legal/cookies",
  },
  cardForm: "/card-form",
}

export const routeParams = {
  countryCode: "country-code",
}
